<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.userDepartment.id === null ? "ADICIONAR NOVO" : "ATUALIZAR" }} DEPARTAMENTO</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      />
    </div>
    <vs-divider class="mb-0"/>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >

      <div class="p-6">
        <!-- Name -->
        <vs-input
          label="Nome"
          v-model="userDepartment.name"
          class="mt-5 w-full"
          name="nome"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('nome')"
        >
          {{ errors.first('nome') }}
        </span>

        <!-- Status -->
        <vs-checkbox class="mt-5 w-full" v-model="userDepartment.activated">
          Ativo
        </vs-checkbox>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="confirmPopup" :disabled="!isFormValid">
        Salvar
      </vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
        Cancelar
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import moduleUserDepartment from '@/store/userDepartment/moduleUserDepartment'

export default {
  name: 'user-departments-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    userDepartment: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          name: '',
          activated: true
        }
      }
    }
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
    confirmPopup() {
      if ( !this.userDepartment.id || this.userDepartment.activated === true ){
        return this.submitData()
      }

      this.$emit('closeSidebar')
      this.$vs.dialog({
        type:'confirm',
        color: 'primary',
        title: `Atenção!`,
        text: 'As opções de seleção de bot passivo vinculadas a esse departamento serão removidas!',
        accept: this.submitData,
        acceptText: 'Entendi',
        cancelText: 'Voltar',
      })
    },
    initValues() {
      this.userDepartment = {
        id: null,
        name: '',
        activated: true
      }
    },
    submitData() {
      const that = this
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.userDepartment.id !== null && this.userDepartment.id >= 0) {
            this.$store.dispatch("userDepartment/update", this.userDepartment).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
              this.$vs.notify({
                color: 'success',
                title: 'Sucesso!',
                text: 'Alteração realizada com sucesso!'
              });
            }).catch(err => {
              console.error(err)
            })
          } else {
            delete this.userDepartment.id
            this.$store.dispatch("userDepartment/add", this.userDepartment).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
              this.$vs.notify({
                color: 'success',
                title: 'Sucesso!',
                text: 'Departamento criado com sucesso!'
              });
            }).catch(err => {
              console.error(err)
            })
          }
        }
      })
    }
  },
  created() {
    if (!moduleUserDepartment.isRegistered) {
      this.$store.registerModule('userDepartment', moduleUserDepartment)
      moduleUserDepartment.isRegistered = true
    }
  },
  components: {
    VuePerfectScrollbar
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
